module.exports = __webpack_public_path__ + "static/media/bufferSettings.7b2a0a01.svg";